function masaBusinessDate(days){const d=new Date();let left=days;while(left>0){d.setDate(d.getDate()+1);if(d.getDay()!==0&&d.getDay()!==6)left--;}return d.toLocaleDateString('en-US',{month:'short',day:'numeric'});}function masaDates(){document.querySelectorAll('[data-masa-delivery]').forEach(el=>{const min=Number(el.dataset.min),max=Number(el.dataset.max);if(Number.isFinite(min)&&Number.isFinite(max)&&min>0&&max>=min&&max<100)el.textContent='Order today → estimated delivery '+masaBusinessDate(min)+' – '+masaBusinessDate(max);});}document.addEventListener('DOMContentLoaded',masaDates);document.addEventListener('shopify:section:load',masaDates);
/* Masa v6.4.7 (+v6.5.0 visible arrow) — small, calm dropdown for header menu items that have sub-links
   (e.g. Comfort Kits). Replaces Horizon's full-width mega panel on desktop only.
   Opens on hover/focus/click, stays open ~0.5s after the pointer leaves. */
(function () {
  if (window.__masaDropdown) return;
  window.__masaDropdown = true;

  var css = [
    '@media (min-width: 750px){',
    '.masa-dd-host > .menu-list__submenu{display:none !important;}',
    '.masa-dd-host .menu-list__trigger{position:relative;display:inline-flex;align-items:center;}',
    '.masa-dd-host .menu-list__disclosure{opacity:1 !important;position:static !important;display:inline-flex !important;align-items:center;align-self:center;width:auto;height:auto;padding:0 2px;margin:0;margin-inline-start:5px;top:auto !important;transform:none !important;cursor:pointer;color:inherit;}',
    '.masa-dd-host .menu-list__disclosure-icon{width:10px;height:6px;transition:transform .2s ease;}',
    '.masa-dd-host.masa-dd-open .menu-list__disclosure-icon{transform:rotate(180deg);}',
    '.masa-dd{position:absolute;top:100%;left:50%;z-index:60;min-width:240px;max-height:70vh;overflow:auto;',
    'margin-top:12px;padding:8px;background:#fafbf8;border:1px solid #d6ded4;border-radius:10px;',
    'box-shadow:0 14px 36px rgba(23,40,29,.14);opacity:0;visibility:hidden;transform:translate(-50%,6px);',
    'transition:opacity .18s ease,transform .18s ease,visibility 0s linear .18s;}',
    '.masa-dd::before{content:"";position:absolute;left:0;right:0;top:-14px;height:14px;}',
    '.masa-dd.is-open{opacity:1;visibility:visible;transform:translate(-50%,0);transition:opacity .18s ease,transform .18s ease,visibility 0s;}',
    '.masa-dd ul{list-style:none;margin:0;padding:0;}',
    '.masa-dd a{display:block;padding:9px 14px;border-radius:6px;font-size:14px;line-height:1.3;color:#253d32;text-decoration:none;white-space:nowrap;}',
    '.masa-dd a:hover,.masa-dd a:focus-visible{background:#e8eee5;color:#214b3a;}',
    '.masa-dd .masa-dd-all{font-weight:600;color:#214b3a;border-bottom:1px solid #e3e8e1;border-radius:6px 6px 0 0;margin-bottom:4px;}',
    '}'
  ].join('');

  function build() {
    if (window.matchMedia && !window.matchMedia('(min-width: 750px)').matches) return;
    var items = document.querySelectorAll('.menu-list__list-item');
    items.forEach(function (li) {
      if (li.classList.contains('masa-dd-host')) return;
      var sub = li.querySelector(':scope > .menu-list__submenu');
      var trigger = li.querySelector(':scope > .menu-list__trigger');
      var parent = li.querySelector(':scope .menu-list__link');
      if (!sub || !trigger || !parent) return;
      var links = Array.prototype.slice.call(sub.querySelectorAll('a[href]'));
      if (!links.length) return;

      var dd = document.createElement('div');
      dd.className = 'masa-dd';
      dd.setAttribute('role', 'menu');
      var ul = document.createElement('ul');
      var all = document.createElement('li');
      all.innerHTML = '<a class="masa-dd-all" role="menuitem"></a>';
      all.firstChild.href = parent.getAttribute('href');
      all.firstChild.textContent = 'Shop all ' + parent.textContent.trim();
      ul.appendChild(all);
      var seen = {};
      links.forEach(function (a) {
        var href = a.getAttribute('href');
        var text = a.textContent.trim();
        if (!text || seen[href]) return;
        seen[href] = true;
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = href;
        link.textContent = text;
        link.setAttribute('role', 'menuitem');
        item.appendChild(link);
        ul.appendChild(item);
      });
      dd.appendChild(ul);
      trigger.appendChild(dd);
      li.classList.add('masa-dd-host');

      var closeTimer;
      function open() { clearTimeout(closeTimer); dd.classList.add('is-open'); li.classList.add('masa-dd-open'); }
      function close() { dd.classList.remove('is-open'); li.classList.remove('masa-dd-open'); }
      function closeSoon() { clearTimeout(closeTimer); closeTimer = setTimeout(close, 500); }
      trigger.addEventListener('pointerenter', open);
      trigger.addEventListener('pointerleave', closeSoon);
      dd.addEventListener('pointerenter', open);
      dd.addEventListener('pointerleave', closeSoon);
      trigger.addEventListener('focusin', open);
      trigger.addEventListener('focusout', function (e) { if (!trigger.contains(e.relatedTarget)) closeSoon(); });
      var btn = li.querySelector('.menu-list__disclosure');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        dd.classList.contains('is-open') ? close() : open();
      }, true);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  window.addEventListener('load', build);
  window.addEventListener('resize', build);
  /* Horizon fills the submenu links in a second render, so keep watching the header briefly */
  var tries = 0;
  var poll = setInterval(function () { build(); if (++tries > 40 || document.querySelector('.masa-dd-host')) clearInterval(poll); }, 250);
  document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('.menu-list__list-item:not(.masa-dd-host)')) build(); });
  if (window.MutationObserver) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 120); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* Masa v6.5.1 — the logo + menu bar shrinks to a slim bar as soon as the shopper starts
   scrolling down, on every page, and returns to full size back at the top.
   Horizon scrolls the window below 990px but .page-wrapper on desktop, so both are watched.
   No manual scroll correction and browser scroll anchoring is off: earlier versions corrected
   the scroll position twice, which pulled the page back and made the bar feel stuck. */
(function () {
  if (window.__masaCompactHeader) return;
  window.__masaCompactHeader = true;

  var css = [
    'html,body,.page-wrapper{overflow-anchor:none;}',
    'header-component{transition:box-shadow .25s ease;}',
    'header-component .header-logo img{transition:height .25s ease;}',
    'html.masa-compact header-component .header-logo img{height:58px !important;width:auto !important;max-width:none;}',
    'html.masa-compact header-component{box-shadow:0 2px 14px rgba(23,40,29,.10);}',
    /* Horizon measures the menu once and pins that height inline on overflow-list's inner list */
    'html.masa-compact header-component overflow-list::part(list){height:58px !important;}',
    'html.masa-compact header-component .header-logo{height:auto !important;}',
    'html.masa-compact header-component .menu-list__link,html.masa-compact header-component .menu-list__list-item > a{font-size:15px;}',
    '@media (max-width:749px){html.masa-compact header-component .header-logo img{height:44px !important;}}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var root = document.documentElement;
  var ON = 30, OFF = 2, ticking = false;

  function wrapper() { return document.querySelector('.page-wrapper'); }
  function pos() {
    var w = wrapper();
    var a = w ? w.scrollTop : 0;
    var b = window.scrollY || window.pageYOffset || 0;
    return Math.max(a, b);
  }

  function update() {
    ticking = false;
    var y = pos();
    var compact = root.classList.contains('masa-compact');
    if (!compact && y > ON) root.classList.add('masa-compact');
    else if (compact && y <= OFF) root.classList.remove('masa-compact');
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  /* scroll events do not bubble, so listen in the capture phase to catch .page-wrapper too */
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  /* first downward wheel/touch shrinks the bar even before the page has moved */
  window.addEventListener('wheel', function (e) { if (e.deltaY > 0 && !root.classList.contains('masa-compact')) root.classList.add('masa-compact'); else onScroll(); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
